import React from "react";
import { default as MuiTabPanel } from "@mui/lab/TabPanel";

function TabPanel(props) {
  return <MuiTabPanel {...props} />;
}

export default TabPanel;
